// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list {
    list-style: none;
    overflow: auto;
    max-height: 30vh;
  }
  
  .list::-webkit-scrollbar {
    width: 5px;
  }
  
  .list::-webkit-scrollbar-track {
    margin-left: 5px;
  }
  
  .list::-webkit-scrollbar-thumb {
    background: darkgrey;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/List/List.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB","sourcesContent":[".list {\n    list-style: none;\n    overflow: auto;\n    max-height: 30vh;\n  }\n  \n  .list::-webkit-scrollbar {\n    width: 5px;\n  }\n  \n  .list::-webkit-scrollbar-track {\n    margin-left: 5px;\n  }\n  \n  .list::-webkit-scrollbar-thumb {\n    background: darkgrey;\n  }\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
